import { render } from "./TicketInput.vue?vue&type=template&id=5a8ff3e0&scoped=true"
import script from "./TicketInput.vue?vue&type=script&lang=js"
export * from "./TicketInput.vue?vue&type=script&lang=js"

import "./TicketInput.vue?vue&type=style&index=0&id=5a8ff3e0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8ff3e0"]])

export default __exports__